import React, { useState } from "react"

import { HeadingLink } from "../../anti/type/type"
import { Button } from "components/anti/buttons/buttons"
import { Slider } from "components/anti/slider/slider"
import { Link } from "components/anti/link/link"
import { useScrollAnim } from "src/components/hooks/hooks"

import pdf from "assets/img/pdf-file.svg"

export const InverstorAnnualReports = ({ data, lang }) => {
    const [trigger, anim] = useScrollAnim()

    const fileFiltered = [...data.pdfFiles.nodes.sort((a, b) => b.pdfFiles.year - a.pdfFiles.year)]

    return (
        <section className="py-main sc-investor-annualReports" ref={trigger}>
            <div className="container mw-xl">
                <HeadingLink className="flex-wrap">
                    <h2 className={`${anim(1)} w-100 w-md-auto`}>{lang === "en" ? "Annual Reports" : "Laporan Tahunan"}</h2>
                    <Button variant="link" className={`text-white ${anim(2)} mr-sm-down-2`} link={`${lang === "en" ? "" : "/id"}/investor/annual`} >
                        {lang === "en" ? "See All Reports" : "Lihat Semua Laporan"}
                    </Button>
                </HeadingLink>
                <Slider
                    visibleInitial={true}
                    visibleXxlDown={true}
                    visibleXlDown={true}
                    visibleLgDown={true}
                    visibleMdDown={true}
                    dotsInitial={false}
                    dotsXxlDown={false}
                    dotsXlDown={false}
                    dotsLgDown={false}
                    dotsMdDown={false}
                    showInitial={8}
                    showXxlDown={7}
                    showXlDown={6}
                    showLgDown={5}
                    showMdDown={4}
                    showSmDown={3.2}
                    arrowsInitial={false}
                    arrowsXxlDown={false}
                    arrowsXlDown={false}
                    arrowsLgDown={false}
                    arrowsMdDown={false}
                >
                    {fileFiltered.map((file, i) => {
                        return (
                            <Link className={`bg-white annualReports-file py-4 ${anim(i + 4)}`} to={file.pdfFiles.file.mediaItemUrl} key={i}>
                                <img src={pdf} className="img-fluid" alt="pdf-file" />
                                <h5 className="mt-2">{file.pdfFiles.year}</h5>
                            </Link>
                        )
                    })}
                </Slider>
            </div>
        </section >
    )
}